import React from 'react';

import { Alert, AlertTitle } from '@mui/material';

import CopyableField from '~/components/Common/CopyableField';

type DisplayOptions = {
  extended: boolean;
};

const statusCodeFormatter = (
  { extended }: DisplayOptions,
  statusCode?: number | null,
  errorCode?: string,
  errorMsg?: string,
) => {
  if (statusCode == 422 && !errorMsg) {
    return (
      <Alert severity="info">
        {extended && <AlertTitle>Corporate Promo - [Verify your email popup]</AlertTitle>}
        {!extended && <AlertTitle title="[Verify your email popup]">Corporate Popup</AlertTitle>}
      </Alert>
    );
  }
  if (statusCode && statusCode > 300) {
    return (
      <Alert severity="warning">
        <AlertTitle>
          <CopyableField title={errorMsg} value={errorCode} label={`[${errorCode}]`} />
          {extended && errorMsg}
        </AlertTitle>
      </Alert>
    );
  }
  if (statusCode === null) {
    return (
      <Alert severity="success">
        <AlertTitle>Logged</AlertTitle>
      </Alert>
    );
  }
  return (
    <Alert severity="success">
      <AlertTitle>{statusCode ?? 'Unknown status code'}</AlertTitle>
    </Alert>
  );
};

export default statusCodeFormatter;
